module.exports = __webpack_public_path__ + "static/media/400282_01.0e3fce26.png";